import {
  Leaf,
  Sparkles,
  ClipboardList,
  UserRound,
  Users,
  Smartphone,
  ShieldCheck,
  MapPin,
  HeartPulse,
  Droplets,
  GlassWater,
  Waves,
} from "lucide-react";

export const PLANS = [
  {
    id: "single",
    title: "1 Tube",
    tubes: 1,
    tabs: 20,
    price: 387,
    tagline: "Starter",
    perTab: "≈ ₹19 / tablet",
  },
  {
    id: "triple",
    title: "3 Tubes",
    tubes: 3,
    tabs: 60,
    price: 999,
    badge: "Best Value",
    tagline: "Most Popular",
    perTab: "≈ ₹16 / tablet",
    save: "Save ₹162",
  },
];

export const FREEBIES = [
  "Free Consultation",
  "Personalised Diet Plan",
  "Dedicated Coach Support",
  "App Access",
];

export const TRUST = [
  { icon: MapPin, label: "Made in India" },
  { icon: ShieldCheck, label: "Secure Checkout" },
  { icon: ClipboardList, label: "Free Diet Plan" },
  { icon: UserRound, label: "Coach Support" },
];

export const FEATURES = [
  {
    icon: Leaf,
    title: "Thoughtful Ingredients",
    body: "Crafted with apple cider vinegar in a convenient, easy-to-take format.",
    span: "md:col-span-2",
  },
  {
    icon: Sparkles,
    title: "Effervescent Format",
    body: "Drop, fizz and sip. A refreshing alternative to hard-to-swallow pills.",
  },
  {
    icon: ClipboardList,
    title: "Personalised Diet Plan",
    body: "A structured plan tailored to your routine — included at no extra cost.",
  },
  {
    icon: UserRound,
    title: "Dedicated Coach",
    body: "Guidance from a coach to help you stay consistent with healthy habits.",
  },
  {
    icon: Users,
    title: "Supportive Community",
    body: "Join a like-minded community focused on building better daily habits.",
    span: "md:col-span-2",
  },
  {
    icon: Smartphone,
    title: "App Access",
    body: "Track your routine and access resources from our companion app.",
  },
];

export const STEPS = [
  { icon: Droplets, num: "01", title: "Drop", body: "Add one tablet to a glass of fresh water." },
  { icon: Sparkles, num: "02", title: "Fizz", body: "Watch it dissolve into a refreshing sparkle." },
  { icon: GlassWater, num: "03", title: "Drink", body: "Sip and enjoy as part of your daily routine." },
  { icon: Waves, num: "04", title: "Repeat", body: "Make it a simple, consistent healthy habit." },
];

export const VALUE_STACK = [
  { label: "ACV Effervescent Tablets", included: true },
  { label: "Expert Consultation", included: true },
  { label: "Personalised Diet Plan", included: true },
  { label: "Dedicated Coach Support", included: true },
  { label: "Community Access", included: true },
  { label: "Companion App", included: true },
];

export const FAQS = [
  {
    q: "What are ACV Effervescent Tablets?",
    a: "They are apple cider vinegar tablets in an effervescent format. Simply drop a tablet in water, let it dissolve and drink — an easy alternative to traditional formats.",
  },
  {
    q: "How many tablets are in one tube?",
    a: "Each tube contains 20 effervescent tablets.",
  },
  {
    q: "What is included for free with my order?",
    a: "Every order includes a free consultation, a personalised diet plan, dedicated coach support and access to our companion app — at no extra cost.",
  },
  {
    q: "How do I use the tablets?",
    a: "Drop one tablet in a glass of water, let it fizz and dissolve completely, then drink. You can make it part of your daily routine.",
  },
  {
    q: "Is it made in India?",
    a: "Yes. Veda Vitals products are proudly made in India.",
  },
  {
    q: "How does checkout work?",
    a: "Choose your bundle, add it to cart and complete a secure checkout. Our team will reach out to set up your consultation and diet plan.",
  },
];

export const CONTACT = {
  email: "vedavitals.in@gmail.com",
  phone: "6265670551",
  address:
    "House No.- 208, Ward No.- 07, Street - Rengari, Village - Behrakhar, PO.- Behrakhar, Block - Kunkuri, Dist - Jashpur, State - Chhattisgarh, Pin Code - 496225.",
};

export const WHATSAPP_NUMBER = "916265670551";

export const TESTIMONIALS = [
  {
    name: "Aarav M.",
    location: "Bengaluru",
    quote:
      "The effervescent format makes it so easy to keep up with. The free diet plan was a genuinely nice surprise.",
  },
  {
    name: "Priya S.",
    location: "Pune",
    quote:
      "Loved how simple the routine is. My coach checks in and keeps me consistent — feels premium end to end.",
  },
  {
    name: "Rahul V.",
    location: "Delhi",
    quote:
      "Clean packaging, refreshing taste and honest guidance. The 3-tube bundle is great value.",
  },
  {
    name: "Neha K.",
    location: "Mumbai",
    quote:
      "Finally a brand that includes real support, not just a product. The app makes tracking effortless.",
  },
];

export const HeartIcon = HeartPulse;

export const INGREDIENTS = [
  {
    name: "Apple Cider Vinegar Powder",
    dose: "500mg",
    body: "The signature ingredient of every tube, in a convenient effervescent form.",
  },
  {
    name: "Garcinia Cambogia Extract",
    dose: "500mg · 60% HCA",
    body: "A well-known botanical extract, standardised to 60% HCA.",
  },
  {
    name: "Sea Buckthorn Extract",
    dose: "100mg",
    body: "A vibrant plant-derived extract used in traditional wellness.",
  },
  {
    name: "Acetic Acid",
    dose: "25mg",
    body: "The characteristic compound naturally associated with apple cider vinegar.",
  },
  {
    name: "Vitamin B6",
    dose: "1.9mg",
    body: "Included to complement your daily nutritional routine.",
  },
  {
    name: "Vitamin B12",
    dose: "2.2mcg",
    body: "An everyday essential, added to round out the blend.",
  },
];

export const WHO_FOR = [
  { icon: HeartPulse, title: "Busy Professionals", body: "Adults who want a simple, no-fuss daily wellness ritual." },
  { icon: Sparkles, title: "Routine Builders", body: "Anyone looking to stay consistent with better daily habits." },
  { icon: GlassWater, title: "On-the-Go Adults", body: "Those who prefer a refreshing drink over swallowing pills." },
  { icon: Users, title: "Guidance Seekers", body: "People who value expert coaching and a personalised plan." },
];

export const GALLERY = [
  { src: "/assets/product_tube.png", alt: "Veda Vitals ACV Premium Blend tube" },
  { src: "/assets/product_lifestyle.png", alt: "Veda Vitals ACV key health benefits" },
  { src: "/assets/glass_fizz.png", alt: "Effervescent tablet dissolving in water" },
];
